export const toAlias = (str = '') => str.toLowerCase().replace(/[ _-]/g, '.')
